import { stringSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { ProjectOrderConfirmationPage } from '@/areas/orders/ProjectOrder/ProjectOrderConfirmationPage';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/projects/$projectId/order/confirmation')({
    staticData: { access: { permissions: ['create:order'] }, chrome: 'none' } satisfies PageStaticData,
    validateSearch: stringSearch({
        payment_intent_client_secret: 'optional',
        payment_intent_id: 'optional',
        redirect_status: 'optional',
        orderSelectionOptionId: 'required',
    }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    const orderSelectionOptionId = Route.useSearch({ select: (search) => search.orderSelectionOptionId });
    const paymentIntentClientSecret = Route.useSearch({ select: (search) => search.payment_intent_client_secret });
    return (
        <ProjectOrderConfirmationPage
            {...pathParams}
            orderSelectionOptionId={orderSelectionOptionId}
            payment_intent_client_secret={paymentIntentClientSecret}
        />
    );
}
